import React from 'react';
import Dialog from '@mui/material/Dialog';
import { VStack, Label } from '@medely/ui-kit';
import useDevice from '../../hooks/useDevice.web';
import { useYouTubePlayer } from '../../hooks/useYouTubePlayer.web';
import { VideoModalProps } from './interface';

const DEFAULT_IFRAME_ID = 'video-modal-iframe';

export const VideoModal = ({
  isOpen,
  onClose,
  videoUrl,
  onVideoPlayed,
  iframeId = DEFAULT_IFRAME_ID,
  testId = 'video-modal',
}: VideoModalProps) => {
  const isMobile = useDevice() === 'mobile';

  useYouTubePlayer({
    iframeId,
    isOpen: isOpen && !!videoUrl,
    onPlay: onVideoPlayed,
  });

  if (!isOpen || !videoUrl) {
    return null;
  }

  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      slotProps={{
        paper: {
          style: {
            margin: isMobile ? 0 : 16,
            borderRadius: isMobile ? 0 : 16,
            overflow: 'visible',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            ...(isMobile && { width: '100%', maxWidth: '100%' }),
          },
        },
        backdrop: {
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          },
        },
      }}
      data-testid={`${testId}-dialog`}
    >
      <VStack gap={3} alignItems="center">
        <div
          style={{
            width: '100%',
            aspectRatio: '16 / 9',
            borderRadius: isMobile ? 0 : 12,
            overflow: 'hidden',
            background: '#000',
          }}
        >
          <iframe
            id={iframeId}
            src={videoUrl}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Video"
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        </div>
        <div onClick={onClose} data-testid={`${testId}-dismiss`} style={{ cursor: 'pointer' }}>
          <Label size="m" color="surface.paper">
            Dismiss
          </Label>
        </div>
      </VStack>
    </Dialog>
  );
};
